import React from 'react';
import { connect } from 'react-redux';
import PurchaseSaleElement from './PurchaseSaleElement.jsx';
import TransportElement from './TransportElement.jsx';
import {
  Button,
} from '../../../form/FormControls.jsx';
import { Row, Col, Glyphicon } from 'react-bootstrap';

export function ElementBuilder(props) {
  let element;
  switch (props.type) {
    case 'purchase':
    case 'sale':
      element = (<Col xs={12} style={{ width: '100%' }}>
        <PurchaseSaleElement
          dealType={props.type}
          dealIdx={props.dealIdx}
          data={props.data}
          lock={props.lock}
          captionAddon={props.captionAddon}
          footerAddon={props.footerAddon}
        />
        <hr className={'deal-list-break'} />
      </Col>);
      break;
    case 'connectpurchase':
    case 'connectsale':
      element = (<Col sm={12} id={`composite_prod_${props.id}`} style={{ paddingLeft: 0 }}>
        <PurchaseSaleElement
          dealType={props.type == 'connectpurchase' ? 'purchase' : 'sale'}
          data={props.data}
          lock={props.lock}
          mode={props.mode}
          handleSelected={props.handleSelected}
          noControlls
          noStatus
          hideLinks
          multiNodalQuantity={props.multiNodalQuantity}
          alerts={props.alerts}
          dealIdx={props.dealIdx}
          withLinks={props.withLinks}
          captionAddon={props.captionAddon}
          footerAddon={props.footerAddon}
        />
        <hr className={'deal-list-break'} />
      </Col>);
      break;
    case 'transport':
      element = (<Col xs={12}>
        <TransportElement
          data={props.data}
          lock={props.lock}
          dealIdx={props.dealIdx}
        />
        <hr className={'deal-list-break'} />
      </Col>);
      break;
    case 'connecttransport':
      element = (<div style={{ width: '100%', display: 'flex' }} id={`composite_prod_${props.id}`}>
        <Col
          xs={10} className="purchase" style={{ paddingRight: 0,
            paddingLeft: '5px' }}
        >
          <TransportElement
            data={props.data}
            lock={props.lock}
            noControlls
          />
        </Col>
        <Col xs={2} style={{ paddingLeft: 0, marginTop: '13px' }}>
          <Button
            bsStyle="success" style={{ height: '100%', width: '100%' }}
            onClick={() => props.connect(props.data.get('id'))}
          >
            <Glyphicon glyph="resize-small">Assign</Glyphicon>
          </Button>
        </Col>
      </div>);
      break;
    default:
      element = <div />;
  }
  return (
    <Row
      style={props.rowStyle ? { fontSize: 13, marginTop: 15, ...props.rowStyle }
        : { fontSize: 13, marginTop: 15 }}
    >
      {element}
    </Row>
  );
}
ElementBuilder.propTypes = {
  data: React.PropTypes.object.isRequired,
  lock: React.PropTypes.object,
  type: React.PropTypes.string,
  dealIdx: React.PropTypes.oneOfType([React.PropTypes.number, React.PropTypes.string]),
  rowStyle: React.PropTypes.object,
  handleSelected: React.PropTypes.func,
  captionAddon: React.PropTypes.func,
  footerAddon: React.PropTypes.func,
  withLinks: React.PropTypes.func,
  multiNodalQuantity: React.PropTypes.number,
};

export default connect((state, props) => ({
  lock: props.data.get('id') ?
    state.getIn(['data', 'locks', props.type, props.data.get('id').toString()]) : undefined,
}))(ElementBuilder);
